export default __webpack_public_path__ + "static/media/avatar_3.4cf28d6d.svg";